module.exports = __webpack_public_path__ + "img/cf2989d.webp";